import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { URLS } from "../../Services/Constant";
import { get, patch, put } from "../../Services/ApiHandler";
import { toast } from "react-toastify";
import { checkPermission } from "../redux/api/PermissionManager";
const SETTINGS_CONFIG = [
  {
    id: "AI CHAT BOT ON/OFF",
    label: "AI Chat Bot",
    isToggle: true,
    payloadKey: "chatbot",
  },
  {
    id: "VOICE TO VOICE ON/OFF",
    label: "Voice to Voice",
    isToggle: true,
    payloadKey: "voice_to_voice",
  },
  {
    id: "RECORDER ON/OFF",
    label: "Recorder",
    isToggle: true,
    payloadKey: "recorder",
  },
  {
    id: "CHAT INPUT TOKEN LIMIT",
    label: "Chat Input Token Limit",
    isToggle: false,
    payloadKey: "chat_input_token_limit",
  },
  {
    id: "CHAT OUTPUT TOKEN LIMIT",
    label: "Chat Output Token Limit",
    isToggle: false,
    payloadKey: "chat_output_token_limit",
  },
  {
    id: "TOTAL INPUT TOKEN",
    label: "Total Output Token",
    isToggle: false,
    payloadKey: "total_input_token",
  },
  {
    id: "TOTAL OUTPUT TOKEN",
    label: "Total Output Token",
    isToggle: false,
    payloadKey: "total_output_token",
  },
];
const normalizeValue = (raw, isToggle) => {
  if (isToggle) {
    return raw === 1 || raw === true || raw === "1" || raw === "true";
  }
  return raw ?? "";
};

function AIWare() {
  const [settingsData, setSettingsData] = useState([]);
  const [rowState, setRowState] = useState({});

  const fetchData = async () => {
    const url = `${URLS.CHAT_BOTGET}`;
    try {
      const res = await get(url);
      const data = res?.data || [];
      setSettingsData(data);

      const nextRowState = {};
      SETTINGS_CONFIG.forEach((cfg) => {
        const item = data.find((d) => d?.type === cfg.id);
        const value = normalizeValue(item?.setting_value, cfg.isToggle);
        nextRowState[cfg.id] = {
          value,
          editValue: value,
          isEdit: false,
          loading: false,
        };
      });
      setRowState(nextRowState);
    } catch (err) {
      console.log("err", err);
      toast.error("Failed to load settings");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const startEdit = (id) => {
    setRowState((prev) => ({
      ...prev,
      [id]: { ...prev[id], isEdit: true, editValue: prev[id].value },
    }));
  };

  const cancelEdit = (id) => {
    setRowState((prev) => ({
      ...prev,
      [id]: { ...prev[id], isEdit: false, editValue: prev[id].value },
    }));
  };

  const handleChange = (id, newEditValue) => {
    setRowState((prev) => ({
      ...prev,
      [id]: { ...prev[id], editValue: newEditValue },
    }));
  };

  const handleSubmitRow = async (cfg) => {
    const { id, isToggle, payloadKey } = cfg;
    const current = rowState[id];
    if (!current) return;

    setRowState((prev) => ({
      ...prev,
      [id]: { ...prev[id], loading: true },
    }));

    const payloadValue = isToggle
      ? Boolean(current.editValue)
      : Number(current.editValue);

    const payload = { [payloadKey]: payloadValue };

    try {
      const res = await put(`${URLS.CHAT_BOTUPDATE}`, payload);

      if (res?.status === "success") {
        toast.success(res?.message || `${cfg.label} updated`);
        setRowState((prev) => ({
          ...prev,
          [id]: {
            ...prev[id],
            value: current.editValue,
            isEdit: false,
            loading: false,
          },
        }));
        fetchData();
      } else {
        throw new Error(res?.message || "Update failed");
      }
    } catch (error) {
      console.error("Submit error:", error);
      toast.error(`Failed to update ${cfg.label}`);
      setRowState((prev) => ({
        ...prev,
        [id]: { ...prev[id], loading: false },
      }));
    }
  };

  const canEdit = checkPermission("CAN-EDIT-SMS_GATEWAY");

  return (
    <div>
      <Topbar header={"Settings"} subHead={"AI Token"} />

      {SETTINGS_CONFIG.map((cfg) => {
        const state = rowState[cfg.id];
        if (!state) return null;

        return (
          <div
            key={cfg.id}
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 10,
              margin: 10,
              alignItems: "center",
            }}
          >
            {cfg.isToggle ? (
              <input
                type="checkbox"
                checked={state.editValue}
                onChange={(e) => handleChange(cfg.id, e.target.checked)}
                style={{ width: 25, height: 25 }}
                disabled={!state.isEdit}
              />
            ) : (
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                value={state.editValue}
                onChange={(e) => {
                  // Strip anything that isn't a digit (allows empty string while typing).
                  const digitsOnly = e.target.value.replace(/[^0-9]/g, "");
                  handleChange(cfg.id, digitsOnly);
                }}
                onKeyDown={(e) => {
                  // Block non-numeric keys (allow navigation/editing keys).
                  const allowedKeys = [
                    "Backspace",
                    "Delete",
                    "ArrowLeft",
                    "ArrowRight",
                    "ArrowUp",
                    "ArrowDown",
                    "Tab",
                    "Home",
                    "End",
                  ];
                  if (
                    allowedKeys.includes(e.key) ||
                    (e.key >= "0" && e.key <= "9")
                  ) {
                    return;
                  }
                  e.preventDefault();
                }}
                disabled={!state.isEdit}
                style={{ width: 100 }}
              />
            )}

            <p style={{ color: "#000", fontSize: 18, minWidth: 220 }}>
              {cfg.label}
            </p>

            {canEdit && (
              <>
                {!state.isEdit ? (
                  <button
                    onClick={() => startEdit(cfg.id)}
                    className="add-btn w-10"
                  >
                    Edit
                  </button>
                ) : (
                  <>
                    <button
                      onClick={() => cancelEdit(cfg.id)}
                      className="reject1-btn w-10"
                    >
                      Cancel
                    </button>
                    &nbsp;
                    <button
                      onClick={() => handleSubmitRow(cfg)}
                      className="add-btn w-10"
                    >
                      {state.loading ? "Loading..." : "Submit"}
                    </button>
                  </>
                )}
              </>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default AIWare;
